import React, { Component } from 'react';

class HeaderAboveContent extends Component {
	render() {
		return null;
	}
}

export default HeaderAboveContent;
